import { render } from "./MailStatusEmptyComponent.vue?vue&type=template&id=24de1d28&scoped=true"
import script from "./MailStatusEmptyComponent.vue?vue&type=script&lang=js"
export * from "./MailStatusEmptyComponent.vue?vue&type=script&lang=js"

import "./MailStatusEmptyComponent.vue?vue&type=style&index=0&id=24de1d28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24de1d28"]])

export default __exports__